import React, { Component } from "react";
import { Link } from "react-router-dom";
import LogOut from "../components/LogOut";
import closedEye from "../assets/eye.png"; // 👁 العين المقفولة
import openEye from "../assets/openeye.png"; // 👁 العين المفتوحة
import editnumber from "../assets/pen-number.png";
import trashicon from "../assets/trash.png";
import plus from "../assets/plus.png";

const isGust = localStorage.getItem("role") === "gust";

export class SEO extends Component {
  state = {
    seoData: [],
    showPopup: false,
    currentSeo: null,
    formData: {},
  };

  componentDidMount() {
    this.fetchSeoData();
  }

  // جلب بيانات SEO لكل المستخدمين
  fetchSeoData = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        "http://backend.goldensection.agency/public/api/getuser",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const data = await res.json();
      if (data.users && data.users.length > 0) {
        // نجمع الـ SEO من كل المستخدمين
        const allSeo = data.users.flatMap((user) => user.seo || []);
        this.setState({ seoData: allSeo });
      }
    } catch (err) {
      console.error("Error fetching SEO data:", err);
    }
  };

  // فتح البوب اب للتعديل
  handleEditClick = (seo) => {
    this.setState({
      showPopup: true,
      currentSeo: seo,
      formData: { ...seo },
    });
  };

  // حذف عنصر
  handleDelete = async (id) => {
    if (window.confirm("هل انت متأكد من الحذف؟")) {
      try {
        const token = localStorage.getItem("token");
        await fetch(
          `http://backend.goldensection.agency/public/api/deleteseo/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        this.fetchSeoData();
      } catch (err) {
        console.error("Error deleting SEO:", err);
      }
    }
  };

  // تعديل القيم في البوب اب
  handleChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value,
      },
    });
  };

  // حفظ التعديلات
  handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      await fetch(
        `http://backend.goldensection.agency/public/api/updateseo/${this.state.currentSeo.id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(this.state.formData),
        },
      );
      this.setState({ showPopup: false, currentSeo: null });
      this.fetchSeoData();
    } catch (err) {
      console.error("Error updating SEO:", err);
    }
  };

  // تفعيل/إلغاء الظهور
  handleToggleStatus = async (seo) => {
    try {
      const token = localStorage.getItem("token");
      const newStatus = seo.status === "on" ? "off" : "on";
      await fetch(
        `http://backend.goldensection.agency/public/api/updateseo/${seo.id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ ...seo, status: newStatus }),
        },
      );
      this.fetchSeoData();
    } catch (err) {
      console.error("Error toggling status:", err);
    }
  };

  render() {
    const { seoData, showPopup, formData } = this.state;

    return (
      <div className="seo-page">
        {/* Navbar */}
        <nav className="seo-navbar">
          <h1 className="nav-title">SEO</h1>
          <LogOut />
          <button className="add1">
            <Link to="/admin">العودة للرئيسية</Link>
          </button>
        </nav>

        {/* Page Content */}
        <div className="admin_area">
          <table className="users-table">
            <thead>
              <tr>
                <th>اسم البراند</th>
                <th>لوجو البراند</th>
                <th>عدد الكلمات المفتاحية المتصدرة</th>
                <th>عدد مرات الظهور العضوي</th>
                <th>مرات النقر والظهور</th>
                <th>عدد المقالات المكتوبة</th>
                <th>عدد وصف المنتجات المكتوبة</th>
                <th>عدد المقالات المحدثة</th>
                <th>عدد المنتجات الخاصة بتحسين السيو</th>
                {!isGust && <th>الإجراءات</th>}
              </tr>
            </thead>
            <tbody>
              {seoData.map((seo) => (
                <tr key={seo.id}>
                  <td>{seo.brand_name}</td>
                  <td>
                    <img
                      src={`http://backend.goldensection.agency/public/api/${seo.logo}`}
                      alt={seo.brand_name}
                      style={{
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                      }}
                    />
                  </td>
                  <td>{seo.keywords_count}</td>
                  <td>{seo.impressions_count}</td>
                  <td>
                    {seo.clicks_count} / {seo.impressions_count}
                  </td>
                  <td>{seo.articles_count}</td>
                  <td>{seo.product_descriptions_count}</td>
                  <td>{seo.updated_articles_count}</td>
                  <td>{seo.seo_products_count}</td>
                  {!isGust && (
                    <td className="editdelet">
                      {/* تعديل */}
                      <button
                        className="delete-btn"
                        onClick={() => this.handleEditClick(seo)}
                      >
                        <img src={editnumber} alt="edit" />
                      </button>
                      {/* تفعيل/إلغاء */}
                      <button
                        className="edit-btn"
                        onClick={() => this.handleToggleStatus(seo)}
                      >
                        <img
                          src={seo.status === "on" ? openEye : closedEye}
                          alt="status"
                        />
                      </button>
                      {/* اضافة محتوى SEO */}

                      <button className="delete-btn">
                        <Link
                          to={{
                            pathname: "/seoupdate",
                          }}
                          state={{ brandName: seo.brand_name, seoId: seo.id }}
                        >
                          <img src={plus} alt="plus" />
                        </Link>
                      </button>

                      {/* حذف */}
                      <button
                        className="delete-btn"
                        onClick={() => this.handleDelete(seo.id)}
                      >
                        <img src={trashicon} alt="delete" />
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Popup */}
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <button
                className="cancel-btn"
                onClick={() => this.setState({ showPopup: false })}
              >
                ×
              </button>
              <h3>تعديل بيانات SEO</h3>
              <input
                type="text"
                name="brand_name"
                value={formData.brand_name || ""}
                onChange={this.handleChange}
                placeholder="اسم البراند"
              />
              <input
                type="text"
                name="keywords_count"
                value={formData.keywords_count || ""}
                onChange={this.handleChange}
                placeholder="عدد الكلمات المفتاحية"
              />
              <input
                type="text"
                name="impressions_count"
                value={formData.impressions_count || ""}
                onChange={this.handleChange}
                placeholder="عدد مرات الظهور"
              />
              <input
                type="text"
                name="clicks_count"
                value={formData.clicks_count || ""}
                onChange={this.handleChange}
                placeholder="عدد النقرات"
              />
              <input
                type="text"
                name="articles_count"
                value={formData.articles_count || ""}
                onChange={this.handleChange}
                placeholder="عدد المقالات"
              />
              <input
                type="text"
                name="product_descriptions_count"
                value={formData.product_descriptions_count || ""}
                onChange={this.handleChange}
                placeholder="عدد وصف المنتجات"
              />
              <input
                type="text"
                name="updated_articles_count"
                value={formData.updated_articles_count || ""}
                onChange={this.handleChange}
                placeholder="عدد المقالات المحدثة"
              />
              <input
                type="text"
                name="seo_products_count"
                value={formData.seo_products_count || ""}
                onChange={this.handleChange}
                placeholder="عدد منتجات SEO"
              />
              <div className="popup-actions">
                <button className="save-btn" onClick={this.handleSave}>
                  حفظ
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SEO;
